import React from 'react'
import Header from '../components/header/Header'
import FloatingButton from '../components/bottomtotop/FloatingButton'
import Footer from '../components/footer/Footer'

const HowToVideos = () => {
  return (
    <div>
        <Header />

        <FloatingButton />
        <Footer />
    </div>
  )
}

export default HowToVideos